module.exports = __webpack_public_path__ + "img/full6-min.363698d2.png";